var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.23 423.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 456.21,
    cy: 326.63,
    fill: "none",
    stroke: "#ffcd52",
    strokeMiterlimit: 10,
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M439.33,341.63c-2.8-6.46-.69-10.42-.69-15,0-9.63,3.23-20.53,9-27.37a52.83,52.83,0,0,1,2.45,15.13C450.06,324,445.07,334.79,439.33,341.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.93,
    cy: 314.46,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M474.25,327.7c0,3.81,1.54,6.85-.56,12-9.05-7.21-15.84-19.32-15.84-31.79a55.47,55.47,0,0,1,1.91-13C468.8,302.06,474.25,315.23,474.25,327.7Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.05,
    cy: 305.95,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.21,
    x2: 456.21,
    y1: 360.73,
    y2: 309.59,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.21,
    x2: 464.18,
    y1: 329.62,
    y2: 320.51,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.21,
    x2: 467.7,
    y1: 340.5,
    y2: 327.37,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.21,
    x2: 468.07,
    y1: 351.72,
    y2: 338.15,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.21,
    x2: 446.55,
    y1: 329.65,
    y2: 318.59,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.21,
    x2: 444.35,
    y1: 340.52,
    y2: 326.96,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 456.21,
    x2: 444.35,
    y1: 351.74,
    y2: 338.18,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.05,
    cy: 305.95,
    fill: "none",
    stroke: "#008ef8",
    strokeMiterlimit: 10,
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "481.05 288.91 481.05 340.05 481.05 360.87"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.05,
    x2: 490.69,
    y1: 308.94,
    y2: 297.91,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.05,
    x2: 492.91,
    y1: 319.82,
    y2: 306.26,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.05,
    x2: 492.91,
    y1: 331.03,
    y2: 317.47,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.05,
    x2: 471.38,
    y1: 308.96,
    y2: 297.91,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.05,
    x2: 469.19,
    y1: 319.84,
    y2: 306.28,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 481.05,
    x2: 469.19,
    y1: 331.06,
    y2: 317.49,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.93,
    cy: 314.46,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "425.93 297.42 425.93 348.56 425.93 360.87"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.93,
    x2: 435.58,
    y1: 317.45,
    y2: 306.42,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.93,
    x2: 437.79,
    y1: 328.33,
    y2: 314.77,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.93,
    x2: 437.79,
    y1: 339.54,
    y2: 325.98,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.93,
    x2: 416.27,
    y1: 317.47,
    y2: 306.42,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.93,
    x2: 414.07,
    y1: 328.35,
    y2: 314.79,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425.93,
    x2: 414.07,
    y1: 339.56,
    y2: 326,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.26,
    x2: 492.91,
    y1: 360.87,
    y2: 360.87,
    fill: "none",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.06,
    height: 98.1,
    x: 42.68,
    y: 182.7,
    fill: "#c1e3f7",
    rx: 13,
    transform: "rotate(45 91.215 231.752)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.32,
    height: 114.32,
    x: 34.05,
    y: 174.59,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 13,
    transform: "rotate(45 91.215 231.752)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M31.34,313.3a78.74,78.74,0,0,1,1.21,7.89c.3,2.63.48,5.27.64,7.91s.23,5.29.21,7.95a79,79,0,0,1-.35,8,78.74,78.74,0,0,1-1.21-7.89c-.3-2.63-.48-5.28-.64-7.92s-.22-5.29-.21-7.94S31.07,316,31.34,313.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M48.06,328.3a79.18,79.18,0,0,1-7.89,1.21c-2.64.3-5.28.48-7.92.65s-5.29.22-7.94.2a76,76,0,0,1-8-.35,75.92,75.92,0,0,1,7.89-1.2c2.63-.3,5.27-.49,7.91-.65s5.29-.22,7.94-.2A79,79,0,0,1,48.06,328.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M103.71,277.21a36.56,36.56,0,0,1,1.06,5.3c.25,1.77.42,3.55.51,5.33s.12,3.56.07,5.35a36.35,36.35,0,0,1-.49,5.38,38,38,0,0,1-1.07-5.3c-.24-1.77-.41-3.54-.5-5.32s-.12-3.57-.07-5.36A36.47,36.47,0,0,1,103.71,277.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M115,287.32a36.16,36.16,0,0,1-5.29,1.06c-1.78.24-3.55.42-5.33.51s-3.56.12-5.35.07a36.35,36.35,0,0,1-5.38-.49,34.93,34.93,0,0,1,5.29-1.07c1.78-.24,3.55-.42,5.33-.51s3.56-.11,5.35-.06A36.35,36.35,0,0,1,115,287.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M175.25,0c.55,2.62.91,5.25,1.2,7.89s.49,5.27.65,7.92.22,5.29.21,7.94a79,79,0,0,1-.36,8c-.55-2.62-.91-5.25-1.2-7.89s-.49-5.27-.65-7.92-.22-5.29-.2-7.94A79,79,0,0,1,175.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M192 15c-2.62.55-5.25.91-7.89 1.2s-5.27.49-7.92.65-5.29.22-7.94.21a79 79 0 01-8-.36c2.62-.55 5.25-.91 7.89-1.2s5.27-.49 7.92-.65 5.29-.22 7.94-.2A76.13 76.13 0 01192 15zM196.18 19.44a36.56 36.56 0 011.06 5.3c.24 1.77.42 3.55.51 5.33s.12 3.56.07 5.35a36.47 36.47 0 01-.49 5.38 36.6 36.6 0 01-1.07-5.3c-.24-1.77-.42-3.55-.51-5.33s-.11-3.56-.06-5.35A36.35 36.35 0 01196.18 19.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M207.43 29.54a37.7 37.7 0 01-5.3 1.07c-1.77.24-3.54.41-5.32.51s-3.57.11-5.35.07a36.63 36.63 0 01-5.39-.5 36.56 36.56 0 015.3-1.06c1.77-.24 3.55-.42 5.33-.51s3.56-.11 5.35-.06A37.73 37.73 0 01207.43 29.54zM10.1 299.21a37.57 37.57 0 011.07 5.29c.24 1.78.41 3.55.51 5.33s.11 3.56.07 5.35a37.77 37.77 0 01-.5 5.38 36.16 36.16 0 01-1.06-5.29c-.24-1.78-.42-3.55-.51-5.33s-.12-3.57-.07-5.35A39.26 39.26 0 0110.1 299.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M21.36 309.31a36.56 36.56 0 01-5.3 1.06c-1.77.25-3.55.42-5.33.51s-3.56.12-5.35.07A36.35 36.35 0 010 310.46a38 38 0 015.3-1.07c1.77-.24 3.54-.41 5.32-.5s3.57-.12 5.36-.07A36.6 36.6 0 0121.36 309.31zM448.55 163.66a78.74 78.74 0 011.21 7.89c.3 2.63.48 5.27.65 7.92s.22 5.29.2 7.94a79 79 0 01-.35 8 75.92 75.92 0 01-1.2-7.89c-.31-2.63-.49-5.27-.65-7.92s-.22-5.29-.21-7.94S448.28 166.33 448.55 163.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M465.27 178.67c-2.62.55-5.26.91-7.89 1.2s-5.28.49-7.92.65-5.29.22-7.94.21a78.84 78.84 0 01-8-.36c2.62-.55 5.25-.91 7.89-1.2s5.27-.49 7.91-.65 5.29-.22 7.95-.2A76.13 76.13 0 01465.27 178.67zM437.53 145.33a37.57 37.57 0 011.07 5.29c.24 1.77.41 3.55.51 5.33s.11 3.56.06 5.35a36.35 36.35 0 01-.49 5.38 36.43 36.43 0 01-1.06-5.29c-.24-1.78-.42-3.55-.51-5.33s-.12-3.57-.07-5.35A39.26 39.26 0 01437.53 145.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M448.79,155.43a36.56,36.56,0,0,1-5.3,1.06c-1.77.24-3.55.42-5.33.51s-3.56.12-5.35.07a36.35,36.35,0,0,1-5.38-.49,36.6,36.6,0,0,1,5.3-1.07c1.77-.24,3.54-.41,5.32-.5s3.57-.12,5.36-.07A36.6,36.6,0,0,1,448.79,155.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d86c1d",
    points: "245.69 203.17 104.28 256.58 221.53 314.88 374.65 256.58 245.69 203.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f46534",
    points: "245.69 203.17 221.53 314.88 374.65 256.58 245.69 203.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffcd52",
    points: "245.69 203.29 374.65 256.58 416.38 257.88 288.88 200.58 245.69 203.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffcd52",
    points: "66.84 238.93 206.69 189.2 245.69 203.17 104.28 256.58 66.84 238.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008ef8",
    d: "M279.87,198.9a51.75,51.75,0,0,1-3.64,15c-2.4,5.8-4.8,8.42-5.92,14.11a24.74,24.74,0,0,0,0,10.92c.81,3.33,2.32,6.13,7.29,12.29,5.7,7.08,7.64,8.27,11.38,12.75,3.6,4.33,6.24,9.16,11.37,18.66,6.68,12.35,10,18.53,10.47,20.94,3.37,17.87-19.64,36.29-23.21,39.14-27.95,22.37-68.53,23.11-98.32,11.38a88.07,88.07,0,0,1-32.77-21.39c-18.39-19.32-22.09-41.87-23.67-52.35-1.22-8.16-5.52-39.71,11.84-69.18,17.63-29.93,40.15-28.09,47.79-55.08,5.82-20.55-2.13-39.69,2.27-41,4.66-1.35,9.45,21.23,31,32.77,6.7,3.59,8.55,2.64,18.09,7.79,12.81,6.92,15.41,11.84,24.24,17.7,20.4,13.53,39,8.79,40,14.56.59,3.18-4.25,8.83-30.95,19.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffcd52",
    points: "221.53 314.88 218.81 423.1 104.28 360.36 104.28 256.58 221.53 314.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd26e",
    points: "221.53 314.88 218.81 423.1 368.41 372.8 374.65 256.58 221.53 314.88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008ef8",
    d: "M291.25,286.29c-.82-7.4,5.8-9.81,13.66-23.21,5.57-9.51,8.29-18.63,11.83-30.5,4.26-14.28,3.64-17.89,8.19-22.3,5.75-5.58,16-8.82,23.67-5,9.68,4.82,10.53,18.65,10.93,25,1.5,24.49-15.13,42.74-21.4,49.62-7.37,8.08-22,24.1-35,20C297.27,298.13,291.93,292.4,291.25,286.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.91,159.13l21.73,8.49s-3.46,19.52-15.38,15.95S209.91,159.13,209.91,159.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#63717c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M209.91,159.13l21.73,8.49s-3.46,19.52-15.38,15.95S209.91,159.13,209.91,159.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M220.77,163.37s-9,15-4.51,20.2C216.26,183.57,223.57,177.93,220.77,163.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M239.54,171l16,14.32s-9.27,15.74-18.41,8.82S239.54,171,239.54,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#63717c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M239.54,171l16,14.32s-9.27,15.74-18.41,8.82S239.54,171,239.54,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M247.55,178.14s-12.54,10-10.4,16C237.15,194.12,245.28,191.61,247.55,178.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0234c1",
    d: "M206.39 183.39a28.64 28.64 0 00-2.78-3 32.8 32.8 0 00-3.1-2.67 33.14 33.14 0 00-7-4.15 32.79 32.79 0 00-7.77-2.37 45.5 45.5 0 00-8.19-.67q1-.12 2.07-.21a18 18 0 012.07-.14 32.31 32.31 0 014.17.26 27.62 27.62 0 018 2.22 28 28 0 017.07 4.46A24.85 24.85 0 01206.39 183.39zM199.71 186.42a33.34 33.34 0 00-7.34-3.12 38.4 38.4 0 00-7.79-1.48c-.66-.1-1.33-.07-2-.12a18.68 18.68 0 00-2 0l-2 0-2 .19a58.37 58.37 0 00-7.88 1.47c1.26-.48 2.52-1 3.81-1.36a38.48 38.48 0 014-.87 32 32 0 018.12-.34 30.81 30.81 0 018 1.75 32.47 32.47 0 013.72 1.63A21.89 21.89 0 01199.71 186.42zM196.07 191c-1.15 0-2.3-.05-3.45 0s-2.29 0-3.43.1a57.26 57.26 0 00-6.8.76 35.22 35.22 0 00-6.55 1.77c-.54.19-1 .46-1.55.69-.26.12-.52.23-.77.37l-.73.44a20.53 20.53 0 00-2.81 2 16.33 16.33 0 012.54-2.37l.71-.52c.24-.16.51-.29.76-.44.51-.27 1-.6 1.54-.84a27.12 27.12 0 016.69-2.05 39.92 39.92 0 0113.85.15zM241.21 199.61a25.15 25.15 0 018.29.45 27.64 27.64 0 017.84 2.9 27.19 27.19 0 016.67 5 30.21 30.21 0 012.73 3.15 15.35 15.35 0 011.16 1.73c.37.58.74 1.17 1.09 1.76a46.33 46.33 0 00-5.51-6.09 33.72 33.72 0 00-6.61-4.72 33.37 33.37 0 00-7.55-3 31.93 31.93 0 00-4-.84A29.74 29.74 0 00241.21 199.61zM242.87 206.76a22.18 22.18 0 013.82 1.33 34.18 34.18 0 013.56 2 31.21 31.21 0 016.22 5.25 32.43 32.43 0 014.68 6.65 38.36 38.36 0 011.71 3.68c.48 1.26.86 2.56 1.25 3.84a59.79 59.79 0 00-3.63-7.14l-1.06-1.68L258.25 219a18.34 18.34 0 00-1.22-1.57c-.44-.49-.82-1-1.3-1.5a38.53 38.53 0 00-5.91-5.28A33.71 33.71 0 00242.87 206.76zM241.47 212.42a39.85 39.85 0 018.55 10.9 27.1 27.1 0 012.44 6.56c.14.56.18 1.15.27 1.73 0 .29.1.58.12.87v.88a16 16 0 01-.33 3.46 21.72 21.72 0 00-.15-3.43l-.09-.84c0-.28-.12-.56-.18-.84-.14-.55-.22-1.11-.4-1.65a35 35 0 00-2.58-6.28 58.23 58.23 0 00-3.53-5.85c-.64-1-1.31-1.87-2-2.79S242.2 213.32 241.47 212.42z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d8821d",
    points: "221.34 322.63 260.95 369 371.26 323.12 374.25 264.38 221.53 314.88 221.34 322.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d8821d",
    points: "180.64 351.59 221.34 322.6 221.53 314.88 104.28 264.17 104.28 305.2 180.64 351.59"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M199.94 143.33l-.7-15.72 9.42 13.69S204.24 138.16 199.94 143.33zM281.59 191l15.7-1-13.54 9.64S286.82 195.18 281.59 191z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffcd52",
    points: "180.64 344 74.69 279.64 104.28 256.58 221.53 314.88 180.64 344"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffcd52",
    points: "405.6 301.19 261.16 361.27 221.53 314.88 374.65 256.58 405.6 301.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8821d",
    d: "M104.28 312a39.23 39.23 0 015.1-4.3 37.76 37.76 0 015.68-3.49 38.57 38.57 0 01-5.1 4.3A39.47 39.47 0 01104.28 312zM104.28 320.53a101.56 101.56 0 018.32-6.63 99.3 99.3 0 018.9-5.82 97.72 97.72 0 01-8.31 6.63A99.46 99.46 0 01104.28 320.53zM104.27 330.07c1.93-1.54 3.92-3 5.93-4.4s4-2.81 6.08-4.18 4.11-2.7 6.21-4l3.15-1.92c1.07-.62 2.12-1.25 3.2-1.84-1 .77-2 1.49-2.93 2.24l-3 2.16c-2 1.43-4 2.81-6.08 4.17s-4.11 2.7-6.21 4S106.43 328.88 104.27 330.07zM104.28 343.21c2.81-2.18 5.69-4.28 8.58-6.37s5.8-4.12 8.72-6.15 5.88-4 8.86-6l4.48-2.91c1.51-.94 3-1.91 4.53-2.83-1.4 1.11-2.84 2.16-4.25 3.23l-4.32 3.15c-2.88 2.09-5.8 4.12-8.73 6.15s-5.88 4-8.86 6S107.33 341.37 104.28 343.21zM104.27 356.1c3.65-2.76 7.36-5.42 11.08-8.08s7.49-5.23 11.24-7.85 7.55-5.14 11.36-7.66l5.73-3.76c1.93-1.23 3.85-2.48 5.79-3.68-1.82 1.39-3.67 2.72-5.51 4.08l-5.57 4c-3.72 2.66-7.49 5.24-11.24 7.86s-7.55 5.14-11.37 7.66S108.15 353.68 104.27 356.1zM112.89 364.81c3.74-2.81 7.55-5.54 11.36-8.26s7.68-5.35 11.51-8 7.74-5.26 11.64-7.84l5.87-3.86c2-1.26 3.93-2.54 5.92-3.77-1.86 1.42-3.76 2.78-5.65 4.17l-5.7 4.09c-3.82 2.71-7.68 5.36-11.51 8s-7.74 5.27-11.65 7.85S116.87 362.34 112.89 364.81zM124.41 371.35c3.74-2.82 7.54-5.55 11.36-8.26s7.67-5.36 11.51-8 7.73-5.27 11.64-7.85l5.86-3.86c2-1.25 3.94-2.54 5.93-3.77-1.87 1.42-3.77 2.79-5.65 4.18l-5.71 4.09c-3.81 2.71-7.67 5.35-11.51 8s-7.74 5.27-11.64 7.85S128.38 368.87 124.41 371.35zM136 377.51c3.74-2.82 7.55-5.55 11.36-8.26s7.68-5.36 11.51-8 7.74-5.27 11.64-7.85l5.87-3.86c2-1.26 3.93-2.54 5.92-3.77-1.86 1.42-3.76 2.78-5.64 4.17L171 354c-3.82 2.71-7.68 5.36-11.51 8s-7.74 5.27-11.65 7.85S140 375 136 377.51zM147.56 383.37c6-4.37 12.05-8.64 18.11-12.9l18.27-12.68 18.4-12.49 9.25-6.17 9.3-6.09-9 6.49-9.08 6.41-18.27 12.67-18.4 12.49C160 375.23 153.79 379.34 147.56 383.37zM220.74 346c-5.16 3.79-10.38 7.49-15.61 11.18s-10.52 7.31-15.77 11-10.58 7.22-15.9 10.78l-8 5.31c-2.68 1.75-5.35 3.52-8.05 5.24 2.57-1.91 5.19-3.76 7.78-5.64l7.83-5.55c5.24-3.69 10.52-7.31 15.77-11s10.58-7.22 15.9-10.77S215.35 349.45 220.74 346zM220.4 359.8c-4.22 3.15-8.5 6.2-12.78 9.24s-8.63 6-12.94 9S186 384 181.62 386.88L175 391.23c-2.22 1.41-4.41 2.86-6.64 4.25 2.1-1.58 4.24-3.1 6.36-4.66l6.42-4.57c4.29-3 8.62-6 12.94-9s8.68-5.92 13.06-8.82S216 362.61 220.4 359.8zM220 374.68c-3.2 2.45-6.46 4.8-9.72 7.14s-6.59 4.62-9.88 6.93-6.65 4.52-10 6.73l-5 3.29c-1.71 1.07-3.39 2.17-5.11 3.21 1.59-1.23 3.22-2.41 4.83-3.61l4.89-3.53c3.27-2.34 6.58-4.61 9.88-6.92s6.64-4.52 10-6.73S216.59 376.79 220 374.68zM219.67 389c-2.22 1.77-4.51 3.46-6.8 5.13s-4.61 3.29-6.94 4.9-4.69 3.19-7.08 4.72L195.27 406c-1.22.73-2.41 1.49-3.65 2.2 1.11-.89 2.25-1.73 3.37-2.6l3.43-2.52c2.28-1.68 4.61-3.3 6.94-4.91s4.69-3.19 7.08-4.72S217.21 390.39 219.67 389zM219.31 403.1a98.81 98.81 0 01-16.43 11.27 87.36 87.36 0 017.93-6.05A88.74 88.74 0 01219.31 403.1zM219 414.75a15.58 15.58 0 01-3.15 2.77 15.77 15.77 0 01-3.71 1.94 17.54 17.54 0 016.86-4.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0234c1",
    d: "M212.79,209.08a11.58,11.58,0,0,1,1.34-4.33,13.39,13.39,0,0,1,2.68-3.64,27.46,27.46,0,0,1-1.79,4.1A43.32,43.32,0,0,1,212.79,209.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M214.58,188.13l14.11,7.76S211.38,213.15,214.58,188.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M381,118.73,292.08,99.58a7.46,7.46,0,0,1-5.89-7.29V51.19a7.46,7.46,0,0,1,7.46-7.46h88.87A7.46,7.46,0,0,1,390,51.19v60.25A7.45,7.45,0,0,1,381,118.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "294.51 100.1 298 109.85 313.71 104.24 294.51 100.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#008ef8",
    points: "313.06 104.47 313.71 104.24 294.51 100.1 295.75 103.55 313.06 104.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#008ef8",
    points: "338.13 92.67 335.28 92.67 331.49 55.79 341.05 53.74 338.13 92.67"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.55,
    cy: 97.86,
    r: 2.24,
    fill: "#008ef8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0234c1",
    d: "M162.9 262.15a35.39 35.39 0 01-6.22-4.27 33.91 33.91 0 01-5-5.66 39.53 39.53 0 01-6-13.89 59.78 59.78 0 01-1.32-15.08 70.18 70.18 0 012.12-14.93c-.42 2.48-.77 5-1 7.46s-.37 5-.37 7.49a63 63 0 001.52 14.83 40.65 40.65 0 005.66 13.69 34.22 34.22 0 004.74 5.73A39.51 39.51 0 00162.9 262.15zM134 238.49c.13 3.46.35 6.91.78 10.32a75.06 75.06 0 002 10.1 55 55 0 003.53 9.63 43.9 43.9 0 005.51 8.68c-.6-.62-1.19-1.25-1.78-1.89s-1.09-1.35-1.64-2-1-1.44-1.46-2.17a24.07 24.07 0 01-1.32-2.25 45.33 45.33 0 01-3.81-9.72 58 58 0 01-1.75-10.28A64.49 64.49 0 01134 238.49zM273.24 245.39a33.33 33.33 0 012 6.73 36.71 36.71 0 01.45 7 44.4 44.4 0 01-3 13.74 64.89 64.89 0 01-6.55 12.42 66.56 66.56 0 01-9 10.76q2.31-2.62 4.37-5.44c1.4-1.85 2.71-3.77 3.94-5.74a69.34 69.34 0 006.27-12.36 53.78 53.78 0 002.08-6.6 49 49 0 001-6.83A36.55 36.55 0 00273.24 245.39zM286.42 290.17a72.38 72.38 0 001.73-7.16 47 47 0 00.77-7.27 40.31 40.31 0 00-.47-7.28 34.2 34.2 0 00-.76-3.59c-.16-.59-.31-1.18-.49-1.77s-.39-1.17-.57-1.76h0v0h0c.29.55.56 1.11.82 1.67s.47 1.15.71 1.73a31.41 31.41 0 011 3.59 30.45 30.45 0 01.72 7.44 34.9 34.9 0 01-1 7.41A36.63 36.63 0 01286.42 290.17z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/emptyCart.7676a3da50903e4227fa7af28cc6cee2.svg";
export { ForwardRef as ReactComponent };